// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d4f91a24","703":"fa078e35","787":"0f148dca"}[chunkId] + ".chunk.js";
};